import React from 'react';
import PropTypes from 'prop-types';
import i18n from '../../utils/i18n';
import isNullOrUndefined from '@adsk/bim360-matrix-react-helpers/es/isNullOrUndefined';
import IssueFieldInlineEdit from './IssueFieldInlineEdit';
import {ISSUE_ATTRIBUTE_NAMES} from '../../constants/issue-attribute-names';
import {issueAttributesType} from '../../constants/proptype-validation/index';
import {updateValueInCustomAttributesArray} from '../../utils/issueAttributes-helpers';
import SelectBoxAdapter from '../common/SelectBoxAdapter';

export default class IssueCustomAttributeDropdownInlineEdit extends React.PureComponent {
  constructor(props) {
    super(props);

    this.getSelectedOption = this.getSelectedOption.bind(this);
    this.getDisplayValue = this.getDisplayValue.bind(this);
    this.getIssueAttributes = this.getIssueAttributes.bind(this);
  }

  parseValue(value) {
    return isNullOrUndefined(value) ? '' : value.toString();
  }

  getIssueAttributes(value) {
    const {customAttribute, issue} = this.props;
    const customAttributes = updateValueInCustomAttributesArray(
      issue[ISSUE_ATTRIBUTE_NAMES.CUSTOM_ATTRIBUTES],
      customAttribute.id,
      value
    );
    return {
      [ISSUE_ATTRIBUTE_NAMES.CUSTOM_ATTRIBUTES]: customAttributes
    };
  }

  getSelectedOptionValue(id) {
    const {customAttribute} = this.props;
    const selectedOption = customAttribute.metadata.list.options.find(option => option.id === id);
    return selectedOption ? selectedOption.value : null;
  }

  getSelectedOption(issue) {
    const {customAttribute} = this.props;
    const issueCustomAttribute = issue[ISSUE_ATTRIBUTE_NAMES.CUSTOM_ATTRIBUTES].find(
      issueAttribute => issueAttribute.attributeDefinitionId === customAttribute.id
    );
    return issueCustomAttribute ? this.parseValue(issueCustomAttribute.value) : null;
  }

  getDisplayValue(id) {
    return this.getSelectedOptionValue(id);
  }

  render() {
    const {disabled, customAttribute, issue, isRequired} = this.props;
    const {id, title, metadata, dataType} = customAttribute;

    const className = 'IssueCustomAttributeDropdownInlineEdit__single-select-list';

    return (
      <IssueFieldInlineEdit
        attributeName={ISSUE_ATTRIBUTE_NAMES.CUSTOM_ATTRIBUTES}
        issue={issue}
        key={id}
        label={title}
        linkify
        styleType={IssueFieldInlineEdit.StyleTypes.SMALL}
        disabled={disabled}
        placeholder={i18n.t('unspecifiedValue')}
        className="IssueCustomAttributeDropdownInlineEdit"
        data-testid={className}
        getFieldValue={this.getSelectedOption}
        getDisplayValue={this.getDisplayValue}
        getIssueAttributes={this.getIssueAttributes}
      >
        {(currentValue, closeEditMode, updateIssue) => (
          <SelectBoxAdapter
            className={className}
            options={metadata[dataType].options}
            autofocus
            openOnFocus
            dropdownMaxWidth={350}
            onClose={closeEditMode}
            onChange={option => updateIssue(option ? option.id : null)}
            searchable
            clearable={!isRequired}
            searchIcon
            selectedOptions={{id: currentValue}}
            labelKey="value"
            valueKey="id"
          />
        )}
      </IssueFieldInlineEdit>
    );
  }
}

IssueCustomAttributeDropdownInlineEdit.propTypes = {
  issue: issueAttributesType,
  customAttribute: PropTypes.object.isRequired,
  disabled: PropTypes.bool,
  isRequired: PropTypes.bool
};
IssueCustomAttributeDropdownInlineEdit.displayName = 'IssueCustomAttributeDropdownInlineEdit';
